/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import DataTableCell from './DataTableCell';
import DataTableRow from './DataTableRow';
import DataTableHeaderCell from './DataTableHeaderCell';

type Props = {
  children: React.ReactNode;
  style?: StyleSet;
};

function DataTable({ children, style }: Props) {
  return <View style={[styles.root, style]}>{children}</View>;
}

DataTable.Cell = DataTableCell;
DataTable.Row = DataTableRow;
DataTable.HeaderCell = DataTableHeaderCell;

let styles = StyleSheet.create({
  root: {
    flex: 1,
  },
});

export default DataTable;
